"use strict";

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/rc-switch/lib/index.js
// module id = 1853
// module chunks = 0